import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { distinct, distinctUntilChanged, map } from 'rxjs/operators';
import { LaneState } from '../modules/control/classes/lane.class';
import { WebSocketService } from './web-socket.service';

@Injectable({
  providedIn: 'root',
})
export class LaneStateService {
  private laneDataSubscription: Subscription;
  private stateSubscription: Subscription;

  private $laneData: BehaviorSubject<LaneState> = new BehaviorSubject(new LaneState());
  private $lastMovements: BehaviorSubject<any> = new BehaviorSubject({});
  private $lastPersons: BehaviorSubject<any> = new BehaviorSubject({});

  private currentPlate: string;
  private newMovement: boolean;
  private currentCard: string;
  private newPerson: boolean;

  constructor(public http: HttpClient, public wsService: WebSocketService) {
    this.newMovement = false;

    // subscripción a IOserver socket paquetes lane_data

    this.laneDataSubscription = this.wsService.listen('lane_data').subscribe((message) => {
      if (message == null) {
        return;
      }
      if (typeof message === 'string') {
        message = JSON.parse(message);
      }
      if (Array.isArray(message)) {
        message.forEach(processLane);
      } else {
        processLane(message);
        processMovement(message);
        processPerson(message);
      }
    });

    // subscripción a io server socket paquetes state

    this.stateSubscription = this.wsService.listen('state').subscribe((message) => {
      if (message == null) {
        return;
      }

      if (typeof message === 'string') {
        message = JSON.parse(message);
      }

      if (Array.isArray(message)) {
        message.forEach(processState);
      } else {
        processState(message);
      }
    });

    const processLane = (ld: any) => {
      if (ld == null) {
        return;
      }
      const actualState = this.$laneData.getValue();
      if (actualState[ld.lane] == null) {
        actualState[ld.lane] = ld;
      }
      actualState[ld.lane] = ld;
      this.$laneData.next(actualState);
    };

    const processState = (state: any) => {
      const actualState = this.$laneData.getValue();
      const id = state.lane;
      if (actualState[id] == null) {
        return;
      }
      actualState[id].state = state;
      this.$laneData.next(actualState);
    };

    //
    // ProcessMovement recive el mennsaje completo que ha llegado por la subscripcion a "lane_data"
    //
    // Guarda el resultado de la matrícula si existe en una variable currentPlate.
    //
    // Hace un push del valor de currentPlate con un timestamp cuando el estado es crossingState.
    // Cada array se guarda indexado. El index se corresponde con el el id de cada lane.
    // Mantiene el array en 5 eleméntos, eliminado el primero.

    const processMovement = (message: any) => {
      if (message == null) {
        return;
      }
      if (message.OCRFrontResultPacket.plate != null || message.OCRFrontResultPacket.plate !== '') {
        this.currentPlate = message.OCRFrontResultPacket.plate;
      }
      if (message.stateMach.currentState === 'crossingState' && this.newMovement) {
        const payload = {
          time: this.getTimeStamp(),
          plate: this.currentPlate,
        };

        const currentMovements = this.$lastMovements.getValue();

        if (currentMovements[message.lane] == null) {
          currentMovements[message.lane] = [];
        }

        currentMovements[message.lane].push(payload);

        if (currentMovements[message.lane].length > 5) {
          currentMovements[message.lane].splice(0, 1);
        }

        this.$lastMovements.next(currentMovements);
        this.newMovement = false;
      }
      if (message.stateMach.currentState === 'readingPlateState') {
        this.newMovement = true;
      }
    };

    const processPerson = (message: any) => {
      if (message == null) {
        return;
      }
      if (message.authResponsePacket?.authorization?.readCard != null || message.authResponsePacket?.authorization?.readCard !== '') {
        this.currentCard = message.authResponsePacket?.authorization?.readCard;
      }
      if (message.stateMach.currentState === 'crossingState' && this.newPerson) {
        const payload = {
          time: this.getTimeStamp(),
          card: this.currentCard,
        };

        const currentPersons = this.$lastPersons.getValue();

        if (currentPersons[message.lane] == null) {
          currentPersons[message.lane] = [];
        }

        currentPersons[message.lane].push(payload);

        if (currentPersons[message.lane].length > 3) {
          currentPersons[message.lane].splice(0, 1);
        }

        this.$lastPersons.next(currentPersons);
        this.newPerson = false;

        console.log('ESTOS SON LOS ULTIMOS datos en Persons', this.$lastPersons);
      }
      if (message.stateMach.currentState === 'authorizingState') {
        this.newPerson = true;
      }
    };
  }

  getStateLane(laneId: any) {
    return this.$laneData.asObservable().pipe(map((lanes) => lanes[laneId]),  distinctUntilChanged());
  }

  getLastMovements(laneId: any) {
    return this.$lastMovements.asObservable().pipe(map((movements) => movements[laneId]));
  }

  getLastPersons(laneId: any) {
    return this.$lastPersons.asObservable().pipe(map((persons) => persons[laneId]));
  }

  OnDestroy() {
    this.laneDataSubscription.unsubscribe();
    this.stateSubscription.unsubscribe();
  }

  /* setStateZero hace una petición al servidor y éste devuelve el estado inicial de las lanes guardado
en el momento de extablecer la conexión por tcp-socket con Servmat*/

  getCurrentLaneData = (laneId: number) => {
    console.log('getCurrentLaneData:  Solicitando estados actuales carriles...');
    this.wsService.send('getLaneData', { laneId });
  };

  getTimeStamp(): string {
    const now: Date = new Date();
    const hours: string = ('0' + now.getHours().toString()).slice(-2);
    const minutes: string = ('0' + now.getMinutes().toString()).slice(-2);

    const time: string[] = [hours, minutes];

    return time.join(':');
  }
}
